<script lang="ts">
  import Arrow from '$icons/ArrowIcon.svelte';
  import { createEventDispatcher } from 'svelte';
    import SimpleCaption from './SimpleCaption.svelte';

  export let value;
  export let label = '';
  export let caption = '';
  export let placeholder = 'Enter here';
  export let danger: boolean = false;
  export let dangerMessage: string = '';

  const dispatch = createEventDispatcher();

  $: {
    value, label;
  }

  function handleSubmit(e) {
    dispatch('change', e, value);
  }
</script>

<div class="flex flex-col items-start gap-2 w-full">
  <label class="text-garden-grey-600 font-medium text-sm" for="">
    {#if label}{label}{:else}&nbsp;{/if}
  </label>
  <div class="relative flex items-center w-full">
    <input
      type="text"
      class="input-selected w-full min-h-[54px] pr-11 border border-garden-grey-300 rounded-14 p-4 placeholder:text-garden-grey-400 text-garden-grey-600 outline-none ease-out duration-100"
      class:input-danger={danger}
      bind:value
      on:focus
      on:blur
      on:keyup={e => {
        dispatch('change', { e, value, label });
      }}
      on:keydown={e => {
        if (e.key === 'Enter') {
          handleSubmit(e);
        }
      }}
      {placeholder}
    />

    <div class="absolute right-0 mr-5">
      <slot>
        <Arrow />
      </slot>
    </div>
  </div>
  <SimpleCaption {danger} {dangerMessage} {caption} />
</div>

<style type="postcss">
  .input-selected:focus {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 4px #ecefff;
  }
  .input-danger {
    @apply border-accent-red-40;
  }
  .input-danger:focus {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 4px #ffecec;
  }
</style>
